/**
 * ADGMQ
 * imedia
 *
 * Forum search form
 */

import $ from 'jquery';

(function($) {
  if ($('body').hasClass('page-template-template-directory')) {
    /**
     * Update form
     */
    $('#searchBy').change(function() {
      var searchBy = $('#searchBy')
        .find(':selected')
        .val();

      $('#search_conference, #search_city, #search_name')
        .hide()
        .find('input')
        .attr('required', false);

      if ($('#search_' + searchBy).length) {
        $('#search_' + searchBy)
          .show()
          .find('input')
          .attr('required', true);
      }
    });

    /**
     * Hide inputs
     */
    $(document).ready(function() {
      $('#search_conference, #search_city, #search_name').each(function() {
        if ($(this).attr('data-show') == 'true') {
          $(this)
            .show()
            .find('input')
            .attr('required', true);
        } else {
          $(this)
            .hide()
            .find('input')
            .attr('required', false);
        }
      });
    });
  }
})(jQuery);
